import "../css/style.scss"



import "../src/modules/gahemo.js"

// alert("Hello! I am an alert box!!");



